'use client';

import { useEffect } from 'react';

import Link from 'next/link';

import { ArrowLeft, MessageCircle } from 'lucide-react';

import { useCaptureException } from '@kit/monitoring/hooks';
import { Button } from '@kit/ui/button';
import { Heading } from '@kit/ui/heading';
import { Trans } from '@kit/ui/trans';

import Header from '~/components/marketing/sections/header';

const GlobalErrorPage = ({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) => {
  useCaptureException(error);

  useEffect(() => {
    console.error('[GlobalErrorPage] A critical error occurred:', error);
    if (error.digest) {
      console.error('[GlobalErrorPage] Error Digest:', error.digest);
    }
  }, [error]);

  return (
    <html>
      <body>
        <div className={'flex h-screen flex-1 flex-col'}>
          <Header user={null} />

          <div
            className={
              'container m-auto flex w-full flex-1 flex-col items-center justify-center'
            }
          >
            <div className={'flex flex-col items-center space-y-8'}>
              <div>
                <h1 className={'font-heading text-9xl font-semibold'}>
                  <Trans i18nKey={'common:errorPageHeading'} />
                </h1>
              </div>

              <div className={'flex flex-col items-center space-y-8'}>
                <div
                  className={
                    'flex max-w-xl flex-col items-center space-y-1 text-center'
                  }
                >
                  <div>
                    <Heading level={2}>
                      <Trans i18nKey={'common:genericError'} />
                    </Heading>
                  </div>

                  <p className={'text-lg text-muted-foreground'}>
                    <Trans i18nKey={'common:genericErrorSubHeading'} />
                  </p>
                </div>

                <div className={'flex space-x-4'}>
                  <Button
                    className={`flex h-11 w-full rounded-3xl text-white sm:w-auto sm:text-sm sm:font-semibold`}
                    variant={'default'}
                    onClick={reset}
                  >
                    <ArrowLeft className={'mr-1 h-4'} />

                    <Trans i18nKey={'common:goBack'} />
                  </Button>

                  <Button
                    className={`flex h-11 w-full rounded-3xl bg-white text-foreground dark:text-background sm:w-auto sm:text-sm sm:font-semibold`}
                    variant={'outline'}
                    asChild
                  >
                    <Link href={'/contact'}>
                      <MessageCircle className={'mr-1 h-4'} />

                      <Trans i18nKey={'common:contactUs'} />
                    </Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </body>
    </html>
  );
};

export default GlobalErrorPage;
